import React, { useState, useEffect, useRef } from "react";
import "./equality-chart-content.css";
import bottleImage from "../../../../../assets/Women-1-new.webp";

const Chart = () => {
  const [waterPercentage, setWaterPercentage] = useState(0);
  const chartSectionRef = useRef(null);

  useEffect(() => {
    const chartSectionNode = chartSectionRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const timer = setTimeout(() => {
              const waterHeight = (28 / 100) * 200; // 30% of the bottle height
              setWaterPercentage(waterHeight);
            }, 300); // Adjust delay time as needed

            return () => clearTimeout(timer);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (chartSectionNode) {
      observer.observe(chartSectionNode);
    }

    return () => {
      if (chartSectionNode) {
        observer.unobserve(chartSectionNode);
      }
    };
  }, []);

  return (
    <div className="chart-section" ref={chartSectionRef}>
      <div className="equality-chart-2-female-container-2">
        <div className="equality-chart-2-female2">
          <img className="equality-chart-2-female-image" src={bottleImage} alt="Bottle" />
          <div className="equality-chart-2-female-water2" style={{ height: waterPercentage }} />
        </div>
      </div>
    </div>
  );
};

export default Chart;
